// Copyright 2025. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { StyledActions } from 'common/components/Actions/Styles';
import {
    Button,
    Icon,
    Translate,
} from '@plesk/ui-library';
import { ICONS } from 'common/constants';
import { dataCySelector } from 'common/tests/selectors';
import { TABLE_ACTIONS } from 'admin/imagePreset/constants/tests';
import ButtonWithConfirmation from 'common/components/ButtonWithConfirmation';
import { IImagePresetResponse } from 'common/api/resources/ImagePreset';

export interface IImagePresetProps {
    item: IImagePresetResponse;
    handleEdit: () => void;
    handleRemove: () => void;
    removeDisabled?: boolean;
}

export const ImagePresetActions: React.FC<IImagePresetProps> = ({
    item,
    handleEdit,
    handleRemove,
    removeDisabled,
}) => (
    <StyledActions>
        <Button
            ghost={true}
            icon={<Icon name={ICONS.PENCIL} size={18} />}
            tooltip={<Translate content="imagePreset.tooltip.edit"/>}
            onClick={handleEdit}
            data-cy={dataCySelector(item.id, TABLE_ACTIONS.EDIT)}
        />
        <ButtonWithConfirmation
            isLoading={item.is_deleting}
            translations={{
                title: (
                    <Translate content="imagePreset.removePopover.title" />
                ),
                button: (
                    <Translate content="imagePreset.removePopover.button" />
                ),
                tooltip: (
                    <Translate content="imagePreset.removePopover.tooltip" />
                ),
            }}
            handleConfirm={handleRemove}
            data-cy={dataCySelector(item.id, TABLE_ACTIONS.REMOVE)}
            icon={ICONS.RECYCLE}
            disabled={removeDisabled}
        />
    </StyledActions>
);